import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["colspan"]
const _hoisted_2 = { class: "flex flex-col items-center justify-center gap-4" }
const _hoisted_3 = { class: "rounded-full bg-white/5 p-4" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-lg font-medium text-zinc-300" }
const _hoisted_6 = { class: "mt-1 text-sm text-zinc-500" }

import { LucideIcon } from 'lucide-vue-next';


export default /*@__PURE__*/_defineComponent({
  __name: 'TableFallback',
  props: {
    colspan: {},
    icon: { type: [Function, Object] },
    title: {},
    description: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", {
      colspan: _ctx.colspan,
      class: "px-6 py-16 text-center"
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icon), { class: "h-8 w-8 text-zinc-400" }))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.description), 1)
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}
}

})